import { render, staticRenderFns } from "./companyVideo.vue?vue&type=template&id=1b0edeec&scoped=true"
import script from "./companyVideo.vue?vue&type=script&lang=js"
export * from "./companyVideo.vue?vue&type=script&lang=js"
import style0 from "./companyVideo.vue?vue&type=style&index=0&id=1b0edeec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0edeec",
  null
  
)

export default component.exports